<script>
	import { Router, Route } from "svelte-routing";
	import Admin from "./routes/Admin.svelte";
	import Front from "./routes/Front.svelte";
	let gate = false;
	let password = sessionStorage.getItem('password');
	// while(password !== 'password2') {
	// 	password = prompt('password');
	// 	sessionStorage.setItem('password', password);
	// }
	gate = true;
</script>

{#if gate}
	<Router>
		<Route path="/" component="{Front}" />
		<Route path="/admin" component="{Admin}" />
	</Router>
{/if}